import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { testimonials, TitleIcon } from '../constants.tsx';

interface Testimonial {
  nameKey: string;
  handle: string;
  avatarUrl: string;
  textKey: string[];
}

const TestimonialCard: React.FC<{ testimonial: Testimonial }> = ({ testimonial }) => {
    const { t } = useTranslation();
    return (
        <div className="testimonial-card h-full p-8 md:p-9 lg:p-8 xl:p-9">
             <div className="absolute -z-10 pointer-events-none inset-0">
                <div className="absolute ltr:right-0 rtl:left-0 bottom-0 w-full h-full bg-gradient-to-tl from-fuchsia-900/10 to-transparent"></div>
            </div>
            <div className="relative z-10">
                <div className="flex items-center gap-4.5 mb-6">
                    <div className="w-12 h-12 rounded-full overflow-hidden shrink-0">
                        <img src={testimonial.avatarUrl} alt={t(testimonial.nameKey)} />
                    </div>
                    <div>
                        <h5 className="text-white text-base font-medium">{t(testimonial.nameKey)}</h5>
                        <p className="font-medium text-sm text-white/60">{testimonial.handle}</p>
                    </div>
                </div>
                <div className="text-white/90 space-y-4">
                    {testimonial.textKey.map((key, index) => (
                        <p key={index}>{t(key)}</p>
                    ))}
                </div>
            </div>
        </div>
    );
}

const Testimonials: React.FC = () => {
    const { t } = useTranslation();
    const [visibleCount, setVisibleCount] = useState(6);
    
    const showMore = () => {
      setVisibleCount(testimonials.length);
    }
    
    const hasMore = visibleCount < testimonials.length;

    return (
        <section className="relative z-20 overflow-hidden pt-20 lg:pt-24 xl:pt-28 pb-20">
            <div className="max-w-6xl mx-auto px-4 sm:px-8 xl:px-0">
                <div className="mb-16 text-center">
                    <span className="hero-subtitle-gradient relative mb-4 font-medium text-sm inline-flex items-center gap-2 py-2 px-4.5 rounded-full">
                        <TitleIcon />
                        <span className="hero-subtitle-text"> {t('testimonialsSectionSubtitle')} </span>
                    </span>
                    <h2 className="text-white mb-4.5 text-2xl font-extrabold sm:text-4xl">
                        {t('testimonialsSectionTitle')}
                    </h2>
                    <p className="max-w-3xl mx-auto font-medium">
                        {t('testimonialsSectionDescription')}
                    </p>
                </div>
                
                <div className="relative">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                       {testimonials.slice(0, visibleCount).map((testimonial, index) => (
                          <TestimonialCard key={index} testimonial={testimonial} />
                       ))}
                    </div>
                    {hasMore && <div className="testimonial-grid-fade"></div>}
                </div>
                
                {hasMore && (
                  <div className="text-center mt-12">
                      <button onClick={showMore} className="header-signup-btn text-sm font-medium flex items-center gap-2 py-2.5 px-6 mx-auto">
                           {t('showMoreButton')}
                      </button>
                  </div>
                )}
            </div>
        </section>
    );
};

export default Testimonials;